module.exports = __webpack_public_path__ + "static/media/tmc-header-logo.95182d6a.png";